import { render } from "./Checkmark.vue?vue&type=template&id=140f6a36&ts=true&lang=pug"
import script from "./Checkmark.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checkmark.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__